import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiConfig} from '../core/config/api.config';
import {SUBSCRIPTIONS_SERVICE} from '../core/config/api.constants';
import {endpoint} from './path.constants';
import {ApiResponse} from './api-response.model';

export interface SubscriptionPlan {
  id: number;
  name: string;
  description: string;
  monthly_price: number;
  yearly_price: number;
  features: string[];
  note: string | null;
  is_featured: boolean;
}

@Injectable({providedIn: 'root'})
export class SubscriptionService {
  private readonly baseUrl = ApiConfig.getBaseUrl(SUBSCRIPTIONS_SERVICE);

  constructor(private http: HttpClient) {}

  getPlans() {
    const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
    return this.http.get<ApiResponse<{plans: SubscriptionPlan[]}>>(
      this.baseUrl + endpoint.subscriptions.plans, {headers}
    );
  }

  verifyExecutiveCode(executive_code: number) {
    const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
    return this.http.post<ApiResponse<any>>(
      this.baseUrl + endpoint.subscriptions.executiveCode, {executive_code}, {headers}
    );
  }

  applyDiscountCode(discount_code: string) {
    const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
    return this.http.post<ApiResponse<{is_valid: boolean; discount: string}>>(
      this.baseUrl + endpoint.subscriptions.discountCode, {discount_code}, {headers}
    );
  }
}
